import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for P503 (Physical Test Approval)
// ============================================================

export interface TestItemInfo {
  code: string;          // 測試項目代號 (F11A_01)
  name: string;          // 測試項目名稱 (F11A_11)
  output_format: number; // 輸出畫面格式 (F11A_15): 1-5
}

export interface PendingItem {
  fp230_01: string;          // 報告單號
  fp230_11: string | null;   // 報告日期 (ISO string)
  fp230_13: string;          // 送件單號
  fp230_14: string;          // 缸號
  fp230_16: string;          // 色名（lookup）
  fp230_18: string;          // 廠商代號
  supplier_name: string;     // 廠商名稱
  fp230_80: string;          // 核准狀態
  selected: boolean;         // 勾選狀態
  test_items: TestItemInfo[]; // 測試項目清單（含輸出格式）
}

export interface QueryResponse {
  items: PendingItem[];
  total: number;
}

export interface ApproveResultItem {
  report_no: string;
  success: boolean;
  message: string;
}

export interface ExecuteResponse {
  results: ApproveResultItem[];
  success: number;
  failed: number;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const p503Api = {
  /** Query pending physical test reports within a range */
  async query(startNo: string, endNo: string): Promise<QueryResponse> {
    const res = await apiClient.post('/api/p503/query', {
      start_no: startNo,
      end_no: endNo,
    });
    return res.data;
  },

  /** Execute batch approval for selected report items */
  async execute(reportNos: string[]): Promise<ExecuteResponse> {
    const res = await apiClient.post('/api/p503/execute', {
      report_nos: reportNos,
      confirmed: true,
    });
    return res.data;
  },
};
